class FeedbackExecutionActionsModalController {
    /*@ngInject*/
    constructor($timeout) {
        this.$timeout = $timeout;
        // this.actionType = this.resolve.actionType;
        // this.jobMatchId = this.resolve.jobMatchId;
        // this.jobId = this.resolve.jobId;
        // this.candidateId = this.resolve.candidateId;
        // this.feedbackType = this.resolve.feedbackType;
        // this.scheduleId = this.resolve.scheduleId;
        // this.feedbackUserIdsList = this.resolve.feedbackUserIdsList;
        // this.editFeedbackApprovalInfo = this.resolve.editFeedbackApprovalInfo;
        // this.isJobProfileLoaded = false;
    }
    $onInit() {
        this.actionType = this.resolve.actionType;
        this.jobMatchId = this.resolve.jobMatchId;
        this.jobId = this.resolve.jobId;
        this.candidateId = this.resolve.candidateId;
        this.feedbackType = this.resolve.feedbackType;
        this.scheduleId = this.resolve.scheduleId;
        this.feedbackUserIdsList = this.resolve.feedbackUserIdsList;
        this.editFeedbackApprovalInfo = this.resolve.editFeedbackApprovalInfo;
        this.isJobProfileLoaded = false;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.title = this._getTitle();
        if (this.feedbackType == 'PhoneScreen') {
            this.workflowStep = 'ps';
        }
        else {
            this.workflowStep = 'in';
        }
        this.$timeout(() => {
            this.isJobProfileLoaded = true;
        }, 3000);
    }
    _getTitle() {
        if (this.actionType == 'candidateBooklet') {
            return 'Candidate Booklet';
        }
        else if (this.actionType == 'jobProfile') {
            return 'Job Profile';
        }
        else {
            return 'Feedback Edit Approval';
        }
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    refresh() {
        this.callbackObject.callbackType = 'refresh';
        this.modalInstance.close(this.callbackObject);
    }
    //Feedback edit approval/denial methods
    saveAndApproveFeedbackEdit() {
        this.callbackObject.callbackType = 'saveAndApproveFeedbackEdit';
        this.modalInstance.close(this.callbackObject);
    }
    approveFeedbackEdit() {
        this.callbackObject.callbackType = 'approveFeedbackEdit';
        this.modalInstance.close(this.callbackObject);
    }
    denyRequestToEditFeedback() {
        this.callbackObject.callbackType = 'denyFeedbackEdit';
        this.modalInstance.close(this.callbackObject);
    }
}
FeedbackExecutionActionsModalController.$inject = ['$timeout'];
// import * as TEMPLATE from './feedback-execution-actions-modal.html;
import * as TEMPLATE from 'raw-loader!./feedback-execution-actions-modal.html';
export const FeedbackExecutionActionsModalComponent = {
    selector: 'feedbackExecutionActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: FeedbackExecutionActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/feedbackExecution/feedbackExecutionActionsModal/feedback-execution-actions-modal.html'
    }
};
//# sourceMappingURL=feedback-execution-actions-modal.component.js.map